import { Helmet } from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryTabs from "./components/CategoryTabs";
import HotRecommend from "./components/HotRecommend";
import LatestUpdates from "./components/LatestUpdates";
import FeaturedSection from "./components/FeaturedSection";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "酷客影院",
  url: "https://www.kukecinema.com",
  description: "酷客影院提供海量高清电影和高清电视剧，支持高清在线观看和超清播放，画质清晰不缓冲，满足追求极致观影体验的用户，最新热门资源持续更新。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.kukecinema.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  return (
    <>
      <Helmet>
        <title>酷客影院-高清电影与高清电视剧在线观看 | 超清播放不缓冲</title>
        <meta name="description" content="酷客影院⚡提供海量高清电影和高清电视剧，🍿支持高清在线观看和超清播放，画质清晰不缓冲，满足追求极致观影体验的用户，最新热门资源持续更新。酷客影院,高清电影,高清电视剧,高清在线观看,超清播放,高清影视,免费高清,最新电影,在线观看" />
        <meta name="keywords" content="酷客影院,高清电影,高清电视剧,高清在线观看,超清播放,高清影视,免费高清,最新电影,在线观看" />
        <link rel="canonical" href="https://www.kukecinema.com/" />
        <meta property="og:title" content="酷客影院-高清电影与高清电视剧在线观看 | 超清播放不缓冲" />
        <meta property="og:description" content="酷客影院提供海量高清电影和高清电视剧，支持高清在线观看和超清播放，画质清晰不缓冲，满足追求极致观影体验的用户。" />
        <meta property="og:url" content="https://www.kukecinema.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="酷客影院" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="酷客影院-高清电影与高清电视剧在线观看" />
        <meta name="twitter:description" content="酷客影院提供海量高清电影和高清电视剧，支持高清在线观看和超清播放。" />
        <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      </Helmet>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryTabs />
          <HotRecommend />
          <LatestUpdates />
          <FeaturedSection />
          <section className="px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-screen-2xl mx-auto bg-background-100 rounded-lg p-6 md:p-10 text-center">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                为什么选择酷客影院？
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto mb-8">
                我们致力于为每一位影迷提供最优质的在线观影体验，高清画质、流畅播放、海量资源，让您足不出户畅享影院级视听盛宴。
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                {[
                  { icon: "ri-4k-line", title: "超清画质", desc: "1080P/4K高清，影院级视听享受" },
                  { icon: "ri-speed-up-line", title: "流畅不卡", desc: "CDN加速节点，告别缓冲等待" },
                  { icon: "ri-database-2-line", title: "海量资源", desc: "万部影视资源，每日持续更新" },
                  { icon: "ri-device-line", title: "多端观看", desc: "电脑/手机/平板，随时随地观影" },
                ].map((item) => (
                  <div key={item.title} className="p-5 rounded-lg bg-background-50">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}